import { render, staticRenderFns } from "./SoundSelect.vue?vue&type=template&id=53107c90&scoped=true"
import script from "./SoundSelect.vue?vue&type=script&lang=js"
export * from "./SoundSelect.vue?vue&type=script&lang=js"
import style0 from "./SoundSelect.vue?vue&type=style&index=0&id=53107c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53107c90",
  null
  
)

export default component.exports